import type { ReactNode } from "react";

interface FilterOption {
  label: string;
  value: string;
}

interface FilterGroup {
  key: string;
  label: string;
  options: FilterOption[];
  value: string;
  onSelect: (value: string) => void;
}

interface FilterPanelProps {
  title: string;
  groups: FilterGroup[];
  onReset: () => void;
  footer?: ReactNode;
}

export default function FilterPanel({
  title,
  groups,
  onReset,
  footer,
}: FilterPanelProps) {
  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-foreground-950">{title}</h3>
        <button
          type="button"
          onClick={onReset}
          className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer"
        >
          <i className="ri-refresh-line"></i>
          重置
        </button>
      </div>

      {groups.map((group) => (
        <div key={group.key}>
          <p className="mb-2.5 text-xs font-medium text-foreground-500">
            {group.label}
          </p>
          <div className="flex flex-wrap gap-2">
            {group.options.map((option) => {
              const active = option.value === group.value;
              return (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => group.onSelect(option.value)}
                  className={`whitespace-nowrap rounded-full px-3 py-1 text-xs transition-colors cursor-pointer ${
                    active
                      ? "bg-primary-600 text-background-50"
                      : "bg-background-100 text-foreground-600 hover:bg-background-200"
                  }`}
                >
                  {option.label}
                </button>
              );
            })}
          </div>
        </div>
      ))}

      {footer}
    </div>
  );
}